class DocunmentData {
    format = (response) => {
        // Multiple files (e.g. a csv/pdf pair) can share a documentGroupId —
        // collapse each group down to exactly one row, keyed by that group.
        const groups = new Map();
        (response?.documents || []).forEach((doc) => {
            const groupId = doc.documentGroupId ?? doc.documentId;
            if (!groups.has(groupId)) groups.set(groupId, doc);
        });

        const documents = [...groups.entries()].map(
            ([documentGroupId, doc]) => {
                const row = {
                    documentId: doc.documentId,
                    documentGroupId,
                    name: doc.name,
                    createdDt: doc.createdDt,
                    modifiedDt: doc.modifiedDt,
                };
                (doc.metadata || []).forEach((entry) => {
                    row[entry.key] = entry.value;
                });
                return row;
            }
        );

        return {
            documents,
            searchResultMetadata: response?.searchResultMetadata,
        };
    };
}

export default new DocunmentData();
